// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cube-container .img {
  position: absolute;
  top: 30px;
  left: 20px;
}

.text {
  margin-top: 400px;
  color: white;
  width: 100%;
  font-weight: 600;
  text-align: center;
  font-family: arial;
}

.cube-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  background-image: radial-gradient(#996bd5, #000917);
}

@keyframes rotate {
  0% {
    transform: rotateX(-37.5deg) rotateY(45deg);
  }
  50% {
    transform: rotateX(-37.5deg) rotateY(405deg);
  }
  100% {
    transform: rotateX(-37.5deg) rotateY(405deg);
  }
}
.cube,
.cube * {
  position: absolute;
  width: 101px;
  height: 101px;
}

.sides {
  animation: rotate 3s ease infinite;
  animation-delay: 0.8s;
  transform-style: preserve-3d;
  transform: rotateX(-37.5deg) rotateY(45deg);
}

.cube .sides * {
  box-sizing: border-box;
  background-color: #996bd5;
  border: 10px solid white;
}

.cube .sides .top {
  animation: top-animation 3s ease infinite;
  animation-delay: 0ms;
  transform: rotateX(90deg) translateZ(100px);
  animation-fill-mode: forwards;
  transform-origin: 50% 50%;
}
@keyframes top-animation {
  0% {
    opacity: 1;
    transform: rotateX(90deg) translateZ(100px);
  }
  20% {
    opacity: 1;
    transform: rotateX(90deg) translateZ(50px);
  }
  70% {
    opacity: 1;
    transform: rotateX(90deg) translateZ(50px);
  }
  90% {
    opacity: 1;
    transform: rotateX(90deg) translateZ(100px);
  }
  100% {
    opacity: 1;
    transform: rotateX(90deg) translateZ(100px);
  }
}
.cube .sides .bottom {
  animation: bottom-animation 3s ease infinite;
  animation-delay: 0ms;
  transform: rotateX(-90deg) translateZ(100px);
  animation-fill-mode: forwards;
  transform-origin: 50% 50%;
}
@keyframes bottom-animation {
  0% {
    opacity: 1;
    transform: rotateX(-90deg) translateZ(100px);
  }
  20% {
    opacity: 1;
    transform: rotateX(-90deg) translateZ(50px);
  }
  70% {
    opacity: 1;
    transform: rotateX(-90deg) translateZ(50px);
  }
  90% {
    opacity: 1;
    transform: rotateX(-90deg) translateZ(100px);
  }
  100% {
    opacity: 1;
    transform: rotateX(-90deg) translateZ(100px);
  }
}
.cube .sides .front {
  animation: front-animation 3s ease infinite;
  animation-delay: 100ms;
  transform: rotateY(0deg) translateZ(100px);
  animation-fill-mode: forwards;
  transform-origin: 50% 50%;
}
@keyframes front-animation {
  0% {
    opacity: 1;
    transform: rotateY(0deg) translateZ(100px);
  }
  20% {
    opacity: 1;
    transform: rotateY(0deg) translateZ(50px);
  }
  70% {
    opacity: 1;
    transform: rotateY(0deg) translateZ(50px);
  }
  90% {
    opacity: 1;
    transform: rotateY(0deg) translateZ(100px);
  }
  100% {
    opacity: 1;
    transform: rotateY(0deg) translateZ(100px);
  }
}
.cube .sides .back {
  animation: back-animation 3s ease infinite;
  animation-delay: 100ms;
  transform: rotateY(-180deg) translateZ(100px);
  animation-fill-mode: forwards;
  transform-origin: 50% 50%;
}
@keyframes back-animation {
  0% {
    opacity: 1;
    transform: rotateY(-180deg) translateZ(100px);
  }
  20% {
    opacity: 1;
    transform: rotateY(-180deg) translateZ(50px);
  }
  70% {
    opacity: 1;
    transform: rotateY(-180deg) translateZ(50px);
  }
  90% {
    opacity: 1;
    transform: rotateY(-180deg) translateZ(100px);
  }
  100% {
    opacity: 1;
    transform: rotateY(-180deg) translateZ(100px);
  }
}
.cube .sides .left {
  animation: left-animation 3s ease infinite;
  animation-delay: 100ms;
  transform: rotateY(-90deg) translateZ(100px);
  animation-fill-mode: forwards;
  transform-origin: 50% 50%;
}
@keyframes left-animation {
  0% {
    opacity: 1;
    transform: rotateY(-90deg) translateZ(100px);
  }
  20% {
    opacity: 1;
    transform: rotateY(-90deg) translateZ(50px);
  }
  70% {
    opacity: 1;
    transform: rotateY(-90deg) translateZ(50px);
  }
  90% {
    opacity: 1;
    transform: rotateY(-90deg) translateZ(100px);
  }
  100% {
    opacity: 1;
    transform: rotateY(-90deg) translateZ(100px);
  }
}
.cube .sides .right {
  animation: right-animation 3s ease infinite;
  animation-delay: 100ms;
  transform: rotateY(90deg) translateZ(100px);
  animation-fill-mode: forwards;
  transform-origin: 50% 50%;
}
@keyframes right-animation {
  0% {
    opacity: 1;
    transform: rotateY(90deg) translateZ(100px);
  }
  20% {
    opacity: 1;
    transform: rotateY(90deg) translateZ(50px);
  }
  70% {
    opacity: 1;
    transform: rotateY(90deg) translateZ(50px);
  }
  90% {
    opacity: 1;
    transform: rotateY(90deg) translateZ(100px);
  }
  100% {
    opacity: 1;
    transform: rotateY(90deg) translateZ(100px);
  }
}

.rolodex {
  height: 2em;
  overflow: hidden;
  font-size: 38px;
  text-align: center;
}

.rolodex ul {
  margin-block-start: 0px;
  margin-block-end: 0px;
  text-align: center;
}

.rolodex > p,
.rolodex ul,
.rolodex li {
  float: left;
  line-height: 2em;
  text-align: center;
}

.rolodex li + li {
  /* clear: left; */
  text-align: center;
}

.rolodex ul {
  list-style: none;
  padding: 0;
  text-align: center;
}

.rolodex .roll-one {
  animation: roll-up-one 10s infinite cubic-bezier(0.75, 0, 0.25, 1);
}
@keyframes roll-up-one {
  0% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-2em);
  }
  50% {
    transform: translateY(-4em);
  }
  75% {
    transform: translateY(-6em);
  }
  100% {
    transform: translateY(-8em);
  }
}
.wrapper {
  display: flex;
  flex-direction: column;
  width: 450px;
  position: absolute;
  top: 80%;
  color: #fff;
}

.timeout {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999999999;
}

/*//End angular-editor customization*/
::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline {
  top: 0.6em !important;
  bottom: 0 !important;
}

::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

::ng-deep .mat-form-field-flex:hover .mat-form-field-outline.mat-form-field-outline-thick {
  color: #05b9ff !important;
}

.mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick {
  color: #05b9ff !important;
}

::ng-deep .mat-form-field-wrapper {
  margin-bottom: -1.25em;
}

/*//End mat-form-field customization*/
mat-expansion-panel-header {
  background-color: #f6f6f6 !important;
  height: 48px !important;
}

mat-panel-title {
  color: #008fc7 !important;
}

/*//End mat-form-field customization*/
::ng-deep .mat-dialog-container {
  display: block;
  padding: 24px;
  border-radius: 4px;
  box-sizing: border-box;
  overflow: auto;
  outline: 0;
  width: 100%;
  height: 100%;
  min-height: inherit;
  max-height: inherit;
}

@media (-ms-high-contrast: active) {
  .mat-dialog-container {
    outline: solid 1px;
  }
}
::ng-deep .mat-dialog-content {
  display: block;
  margin: 0 -24px;
  padding: 0 24px;
  max-height: 65vh;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

::ng-deep .mat-dialog-title {
  margin: 0 0 20px;
  display: block;
}

::ng-deep .mat-dialog-actions {
  padding: 8px 0;
  display: flex;
  flex-wrap: wrap;
  min-height: 52px;
  align-items: center;
  margin-bottom: -24px;
}

::ng-deep .mat-dialog-actions[align=end] {
  justify-content: flex-end;
}

::ng-deep .mat-dialog-actions[align=center] {
  justify-content: center;
}

::ng-deep .mat-dialog-actions .mat-button-base + .mat-button-base {
  margin-left: 8px;
}

::ng-deep [dir=rtl] .mat-dialog-actions .mat-button-base + .mat-button-base {
  margin-left: 0;
  margin-right: 8px;
}

::ng-deep .mat-mdc-dialog-surface .mdc-dialog__surface {
  display: block;
  padding: 24px;
  border-radius: 4px;
  box-sizing: border-box;
  overflow: auto;
  outline: 0;
  width: 100%;
  height: 100%;
  min-height: inherit;
  max-height: inherit;
}

::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {
  display: block !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
  overflow: auto !important;
  outline: 0 !important;
  width: 100% !important;
  height: 100% !important;
  min-height: inherit !important;
  max-height: inherit !important;
}

.mat-expansion-panel-header-title {
  color: #008fc7;
}

.custom-dialog .mat-mdc-dialog-container {
  display: block !important;
  padding: 24px !important;
  border-radius: 4px !important;
  overflow: auto !important;
  height: 100% !important;
}

.cdk-overlay-container, .mat-select-panel {
  z-index: 1050 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAOA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AANF;;AASA;EACE,iBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AANF;;AASA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,mDAAA;AANF;;AASA;EACE;IACE,2CAAA;EANF;EAQA;IACE,4CAAA;EANF;EAQA;IACE,4CAAA;EANF;AACF;AASA;;EAEE,kBAAA;EACA,YAAA;EACA,aAAA;AAPF;;AAUA;EACE,kCAAA;EACA,qBAAA;EACA,4BAAA;EACA,2CAAA;AAPF;;AAUA;EACE,sBAAA;EACA,yBAAA;EACA,wBAAA;AAPF;;AAWE;EACE,yCAAA;EACA,oBAAA;EACA,2CAAA;EACA,6BAAA;EACA,yBAAA;AARJ;AAWE;EACE;IACE,UAAA;IACA,2CAAA;EATJ;EAWE;IACE,UAAA;IACA,0CAAA;EATJ;EAWE;IACE,UAAA;IACA,0CAAA;EATJ;EAWE;IACE,UAAA;IACA,2CAAA;EATJ;EAWE;IACE,UAAA;IACA,2CAAA;EATJ;AACF;AAnBE;EACE,4CAAA;EACA,oBAAA;EACA,4CAAA;EACA,6BAAA;EACA,yBAAA;AAqBJ;AAlBE;EACE;IACE,UAAA;IACA,4CAAA;EAoBJ;EAlBE;IACE,UAAA;IACA,2CAAA;EAoBJ;EAlBE;IACE,UAAA;IACA,2CAAA;EAoBJ;EAlBE;IACE,UAAA;IACA,4CAAA;EAoBJ;EAlBE;IACE,UAAA;IACA,4CAAA;EAoBJ;AACF;AAhDE;EACE,2CAAA;EACA,sBAAA;EACA,0CAAA;EACA,6BAAA;EACA,yBAAA;AAkDJ;AA/CE;EACE;IACE,UAAA;IACA,0CAAA;EAiDJ;EA/CE;IACE,UAAA;IACA,yCAAA;EAiDJ;EA/CE;IACE,UAAA;IACA,yCAAA;EAiDJ;EA/CE;IACE,UAAA;IACA,0CAAA;EAiDJ;EA/CE;IACE,UAAA;IACA,0CAAA;EAiDJ;AACF;AA7EE;EACE,0CAAA;EACA,sBAAA;EACA,6CAAA;EACA,6BAAA;EACA,yBAAA;AA+EJ;AA5EE;EACE;IACE,UAAA;IACA,6CAAA;EA8EJ;EA5EE;IACE,UAAA;IACA,4CAAA;EA8EJ;EA5EE;IACE,UAAA;IACA,4CAAA;EA8EJ;EA5EE;IACE,UAAA;IACA,6CAAA;EA8EJ;EA5EE;IACE,UAAA;IACA,6CAAA;EA8EJ;AACF;AA1GE;EACE,0CAAA;EACA,sBAAA;EACA,4CAAA;EACA,6BAAA;EACA,yBAAA;AA4GJ;AAzGE;EACE;IACE,UAAA;IACA,4CAAA;EA2GJ;EAzGE;IACE,UAAA;IACA,2CAAA;EA2GJ;EAzGE;IACE,UAAA;IACA,2CAAA;EA2GJ;EAzGE;IACE,UAAA;IACA,4CAAA;EA2GJ;EAzGE;IACE,UAAA;IACA,4CAAA;EA2GJ;AACF;AAvIE;EACE,2CAAA;EACA,sBAAA;EACA,2CAAA;EACA,6BAAA;EACA,yBAAA;AAyIJ;AAtIE;EACE;IACE,UAAA;IACA,2CAAA;EAwIJ;EAtIE;IACE,UAAA;IACA,0CAAA;EAwIJ;EAtIE;IACE,UAAA;IACA,0CAAA;EAwIJ;EAtIE;IACE,UAAA;IACA,2CAAA;EAwIJ;EAtIE;IACE,UAAA;IACA,2CAAA;EAwIJ;AACF;;AAxHA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AA2HF;;AAxHA;EAEE,uBAAA;EAEA,qBAAA;EACA,kBAAA;AA2HF;;AAxHA;;;EAGE,WAAA;EACA,gBAAA;EACA,kBAAA;AA2HF;;AAxHA;EACE,iBAAA;EACA,kBAAA;AA2HF;;AAxHA;EACE,gBAAA;EACA,UAAA;EACA,kBAAA;AA2HF;;AAxHA;EAEE,kEAAA;AA2HF;AA7FA;EACE;IAEE,wBAAA;EAsHF;EAnHA;IAEE,2BAAA;EAqHF;EAlHA;IAEE,2BAAA;EAoHF;EAjHA;IAEE,2BAAA;EAmHF;EAhHA;IAEE,2BAAA;EAkHF;AACF;AA/GA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AAiHF;;AA9GA;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;AAiHD;;AAxGE,qCAAA;AAEA;EACE,qBAAA;EACA,oBAAA;AA0GJ;;AArGE;EACE,wCAAA;AAwGJ;;AAjGE;EAGE,yBAAA;AAkGJ;;AA/FE;EACE,yBAAA;AAkGJ;;AA9FE;EACE,sBAAA;AAiGJ;;AA/FE,qCAAA;AACA;EACE,oCAAA;EACA,uBAAA;AAkGJ;;AAhGA;EACE,yBAAA;AAmGF;;AAjGE,qCAAA;AAKF;EACE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAgGF;;AA7FA;EACE;IACI,kBAAA;EAgGJ;AACF;AA7FA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iCAAA;AA+FF;;AA5FA;EACE,gBAAA;EACA,cAAA;AA+FF;;AA5FA;EACE,cAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AA+FF;;AA5FA;EACE,yBAAA;AA+FF;;AA5FA;EACE,uBAAA;AA+FF;;AA5FA;EACE,gBAAA;AA+FF;;AA5FA;EACE,cAAA;EACA,iBAAA;AA+FF;;AA3FA;EAEE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AA6FF;;AAxFA;EACE,yBAAA;EAEA,6BAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,8BAAA;AA0FF;;AApFA;EACE,cAAA;AAuFF;;AAnFA;EACE,yBAAA;EACA,wBAAA;EACA,6BAAA;EACA,yBAAA;EACA,uBAAA;AAsFF;;AAlFA;EACE,wBAAA;AAqFF","sourcesContent":["\r\n  \r\n\r\n\r\n////////////////////////////////loading Cube//////////\r\n$size: 100px;\r\n\r\n.cube-container .img {\r\n  position: absolute;\r\n  top: 30px;\r\n  left: 20px;\r\n}\r\n\r\n.text {\r\n  margin-top: $size * 4;\r\n  color: white;\r\n  width: 100%;\r\n  font-weight: 600;\r\n  text-align: center;\r\n  font-family: arial;\r\n}\r\n\r\n.cube-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: row;\r\n  margin: 0 auto;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-image: radial-gradient(#996bd5, #000917);\r\n}\r\n\r\n@keyframes rotate {\r\n  0% {\r\n    transform: rotateX(-37.5deg) rotateY(45deg);\r\n  }\r\n  50% {\r\n    transform: rotateX(-37.5deg) rotateY(405deg);\r\n  }\r\n  100% {\r\n    transform: rotateX(-37.5deg) rotateY(405deg);\r\n  }\r\n}\r\n\r\n.cube,\r\n.cube * {\r\n  position: absolute;\r\n  width: $size + 1;\r\n  height: $size + 1;\r\n}\r\n\r\n.sides {\r\n  animation: rotate 3s ease infinite;\r\n  animation-delay: 0.8s;\r\n  transform-style: preserve-3d;\r\n  transform: rotateX(-37.5deg) rotateY(45deg);\r\n}\r\n\r\n.cube .sides * {\r\n  box-sizing: border-box;\r\n  background-color: #996bd5;\r\n  border: $size / 10 solid white;\r\n}\r\n\r\n@mixin side($name, $rotate, $i) {\r\n  .#{$name} {\r\n    animation: #{$name}-animation 3s ease infinite;\r\n    animation-delay: $i * 100ms;\r\n    transform: #{$rotate} translateZ($size);\r\n    animation-fill-mode: forwards;\r\n    transform-origin: 50% 50%;\r\n  }\r\n\r\n  @keyframes #{$name}-animation {\r\n    0% {\r\n      opacity: 1;\r\n      transform: #{$rotate} translateZ($size);\r\n    }\r\n    20% {\r\n      opacity: 1;\r\n      transform: #{$rotate} translateZ($size / 2);\r\n    }\r\n    70% {\r\n      opacity: 1;\r\n      transform: #{$rotate} translateZ($size / 2);\r\n    }\r\n    90% {\r\n      opacity: 1;\r\n      transform: #{$rotate} translateZ($size);\r\n    }\r\n    100% {\r\n      opacity: 1;\r\n      transform: #{$rotate} translateZ($size);\r\n    }\r\n  }\r\n}\r\n\r\n.cube .sides {\r\n  @include side(\"top\", rotateX(90deg), 0);\r\n  @include side(\"bottom\", rotateX(-90deg), 0);\r\n  @include side(\"front\", rotateY(0deg), 1);\r\n  @include side(\"back\", rotateY(-180deg), 1);\r\n  @include side(\"left\", rotateY(-90deg), 1);\r\n  @include side(\"right\", rotateY(90deg), 1);\r\n}\r\n\r\n////////////////////////////////loading Cube//////////\r\n\r\n\r\n.rolodex {\r\n  height: 2em;\r\n  overflow: hidden;\r\n  font-size: 38px;\r\n  text-align: center;\r\n}\r\n\r\n.rolodex ul {\r\n  -webkit-margin-before: 0px;\r\n  margin-block-start: 0px;\r\n  -webkit-margin-after: 0px;\r\n  margin-block-end: 0px;\r\n  text-align: center;\r\n}\r\n\r\n.rolodex > p,\r\n.rolodex ul,\r\n.rolodex li {\r\n  float: left;\r\n  line-height: 2em;\r\n  text-align: center;\r\n}\r\n\r\n.rolodex li + li {\r\n  /* clear: left; */\r\n  text-align: center;\r\n}\r\n\r\n.rolodex ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  text-align: center;\r\n}\r\n\r\n.rolodex .roll-one {\r\n  -webkit-animation: roll-up-one 10s infinite cubic-bezier(0.75, 0, 0.25, 1);\r\n  animation: roll-up-one 10s infinite cubic-bezier(0.75, 0, 0.25, 1);\r\n}\r\n\r\n@-webkit-keyframes roll-up-one {\r\n  0% {\r\n    -webkit-transform: translateY(0);\r\n    transform: translateY(0);\r\n  }\r\n\r\n  25% {\r\n    -webkit-transform: translateY(-2em);\r\n    transform: translateY(-2em);\r\n  }\r\n\r\n  50% {\r\n    -webkit-transform: translateY(-4em);\r\n    transform: translateY(-4em);\r\n  }\r\n\r\n  75% {\r\n    -webkit-transform: translateY(-6em);\r\n    transform: translateY(-6em);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateY(-8em);\r\n    transform: translateY(-8em);\r\n  }\r\n}\r\n\r\n@keyframes roll-up-one {\r\n  0% {\r\n    -webkit-transform: translateY(0);\r\n    transform: translateY(0);\r\n  }\r\n\r\n  25% {\r\n    -webkit-transform: translateY(-2em);\r\n    transform: translateY(-2em);\r\n  }\r\n\r\n  50% {\r\n    -webkit-transform: translateY(-4em);\r\n    transform: translateY(-4em);\r\n  }\r\n\r\n  75% {\r\n    -webkit-transform: translateY(-6em);\r\n    transform: translateY(-6em);\r\n  }\r\n\r\n  100% {\r\n    -webkit-transform: translateY(-8em);\r\n    transform: translateY(-8em);\r\n  }\r\n}\r\n\r\n.wrapper {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 450px;\r\n  position: absolute;\r\n  top: 80%;\r\n  color: #fff;\r\n}\r\n \r\n.timeout{\r\n position: fixed;\r\n top: 0;\r\n left: 0;\r\n width: 100%;\r\n z-index: 999999999;\r\n  }\r\n\r\n\r\n\r\n\r\n  \r\n\r\n\r\n  /*//End angular-editor customization*/\r\n\r\n  ::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline {\r\n    top: 0.6em !important;\r\n    bottom: 0 !important;\r\n  }\r\n  \r\n  \r\n  \r\n  ::ng-deep .mdc-text-field--filled:not(.mdc-text-field--disabled){\r\n    background-color: transparent !important;\r\n  \r\n  }\r\n  \r\n  \r\n  \r\n  \r\n  ::ng-deep\r\n    .mat-form-field-flex:hover\r\n    .mat-form-field-outline.mat-form-field-outline-thick {\r\n    color: #05b9ff !important;\r\n  }\r\n  \r\n  .mat-form-field-appearance-outline.mat-focused .mat-form-field-outline-thick {\r\n    color: #05b9ff !important;\r\n  }\r\n  \r\n  \r\n  ::ng-deep .mat-form-field-wrapper{\r\n    margin-bottom: -1.25em;\r\n  }\r\n  /*//End mat-form-field customization*/\r\n  mat-expansion-panel-header {\r\n    background-color: #f6f6f6 !important;\r\n    height: 48px !important;\r\n}\r\nmat-panel-title {\r\n  color: #008fc7 !important;\r\n}\r\n  /*//End mat-form-field customization*/\r\n\r\n\r\n  \r\n\r\n::ng-deep .mat-dialog-container {\r\n  display: block;\r\n  padding: 24px;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n  overflow: auto;\r\n  outline: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  min-height: inherit;\r\n  max-height: inherit\r\n}\r\n\r\n@media (-ms-high-contrast:active) {\r\n  .mat-dialog-container {\r\n      outline: solid 1px\r\n  }\r\n}\r\n\r\n::ng-deep .mat-dialog-content {\r\n  display: block;\r\n  margin: 0 -24px;\r\n  padding: 0 24px;\r\n  max-height: 65vh;\r\n  overflow: auto;\r\n  -webkit-overflow-scrolling: touch\r\n}\r\n\r\n::ng-deep  .mat-dialog-title {\r\n  margin: 0 0 20px;\r\n  display: block\r\n}\r\n\r\n::ng-deep  .mat-dialog-actions {\r\n  padding: 8px 0;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  min-height: 52px;\r\n  align-items: center;\r\n  margin-bottom: -24px\r\n}\r\n\r\n::ng-deep .mat-dialog-actions[align=end] {\r\n  justify-content: flex-end\r\n}\r\n\r\n::ng-deep  .mat-dialog-actions[align=center] {\r\n  justify-content: center\r\n}\r\n\r\n::ng-deep  .mat-dialog-actions .mat-button-base+.mat-button-base {\r\n  margin-left: 8px\r\n}\r\n\r\n::ng-deep  [dir=rtl] .mat-dialog-actions .mat-button-base+.mat-button-base {\r\n  margin-left: 0;\r\n  margin-right: 8px\r\n}\r\n\r\n\r\n::ng-deep .mat-mdc-dialog-surface .mdc-dialog__surface {\r\n\r\n  display: block;\r\n  padding: 24px;\r\n  border-radius: 4px;\r\n  box-sizing: border-box;\r\n  overflow: auto;\r\n  outline: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  min-height: inherit;\r\n  max-height: inherit;\r\n}\r\n\r\n\r\n\r\n::ng-deep .mat-mdc-dialog-container .mdc-dialog__surface {\r\n  display: block !important;\r\n  // padding: 24px !important;\r\n  border-radius: 4px !important;\r\n  box-sizing: border-box !important;\r\n  overflow: auto !important;\r\n  outline: 0 !important;\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  min-height: inherit !important;\r\n  max-height: inherit !important;\r\n}\r\n\r\n\r\n\r\n\r\n.mat-expansion-panel-header-title{\r\n  color: #008fc7;\r\n}\r\n\r\n\r\n.custom-dialog .mat-mdc-dialog-container {\r\n  display: block !important;\r\n  padding: 24px !important;\r\n  border-radius: 4px !important;\r\n  overflow: auto !important;\r\n  height: 100% !important;\r\n}\r\n\r\n\r\n.cdk-overlay-container, .mat-select-panel {\r\n  z-index: 1050 !important;\r\n}\r\n// .cdk-overlay-container {\r\n//   position: absolute;\r\n//   z-index: 1 !important ; \r\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
